import dynamic from 'next/dynamic';
import type { FunctionComponent } from 'react';
import type { SectionFragment } from '../../../graphql/fragments/SectionFragment.graphql';
const FeatureReview = dynamic(import('./review'));
const FEATURE_COMPONENTS = {
  Review: FeatureReview
};
export const SectionFeature: FunctionComponent<Props> = ({
  feature,
  fallback = null
}) => {
  // if no feature, render fallback
  if (!feature) return <>{fallback}</>;

  // if no type on feature, render nothing
  if (typeof feature?.type !== 'string') return null;
  const Component = FEATURE_COMPONENTS[feature.type];

  // if type is not in registry, warn and render nothing
  if (!Component) {
    console.warn(`A section of type "${feature.type}" was found, but is undefined in the registry.`);
    return null;
  }
  return <Component {...feature} data-sentry-element="Component" data-sentry-component="SectionFeature" data-sentry-source-file="index.tsx" />;
};
interface Props extends Pick<SectionFragment, 'feature'> {
  fallback?: React.ReactNode;
}